import type {
	BreakpointRange,
	BaseDataItem,
	WRichTextDefinition,
	Style,
	Component,
	VectorImageData,
} from '@wix/thunderbolt-becky-types'

export const isBreakpointRange = (item: BaseDataItem): item is BreakpointRange => item.type === 'BreakpointRange'
export const isStyledText = (item?: BaseDataItem): item is WRichTextDefinition['data'] => item?.type === 'StyledText'
export const isVectorImage = (item?: BaseDataItem): item is VectorImageData => item?.type === 'VectorImage'
export const isStylable = (style?: Style) => {
	const properties = style?.style?.properties
	return properties && ('$st-css' in properties || 'st-css' in properties)
}
export const isRichTextComponent = (component: Component) =>
	component.componentType === 'WRichText' || component.componentType === 'MediaRichText'
